import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { deleteSMSTemp, rowSorting, smsTemp } from "../../../../store/actions";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTablePagination,
} from "../../../../Common/DataTable";
import Filters from "./Filters";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "name",
    align: false,
    disablePadding: true,
    label: "Name",
    title: "Name",
    order: 1,
  },

  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
];

const SMSIndex = () => {
  const dispatch = useDispatch();
  const [deleteShow, deleteSetShow] = useState(false);
  const deleteClose = () => deleteSetShow(false);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({
    orderBy: "sort_index",
    order: "asc",
    page: 0,
    limit: 20,
    searchBy: "name",
    search: "",
  });
  const [dragUsers, setDragUsers] = useState("");

  const [Delete, setDelete] = useState({
    open: false,
    dumpId: "",
  });

  const EmailTempList = useSelector(
    (s) => s?.EmailTemplates?.smsTemplates?.data
  );
  const totalCount = useSelector(
    (s) => s?.EmailTemplates?.smsTemplates?.total_count
  );

  useEffect(() => {
    if (EmailTempList) {
      setDragUsers(EmailTempList);
    }
  }, [EmailTempList]);

  useEffect(() => {
    if (EmailTempList && EmailTempList != undefined) {
      setLoading(false);
    }
  }, [EmailTempList]);

  const getTableRecords = () => {
    let body = {
      orderBy: state.orderBy,
      order: state.order,
      page: state.page,
      limit: state.limit,
      searchBy: state.searchBy,
      search: filter,
    };

    dispatch(smsTemp(body));
  };

  useEffect(() => {
    dispatch(smsTemp(state));
  }, [state]);

  useEffect(() => {
    getTableRecords(state.order, state.orderBy);
  }, [state]);

  const resetFilter = () => {
    setState((pre) => ({
      ...pre,
      search: "",
    }));
    setFilter("");
  };

  const handleChangePage = (event, page) => {
    setState((pre) => ({
      ...pre,
      page: page,
    }));
    // getTableRecords(state.order, state.orderBy);
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setFilter(value);
  };

  const handleStatus = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setState((pre) => ({
      ...pre,
      search: value,
    }));
  };

  const filterdata = (e) => {
    e.preventDefault();
    getTableRecords(1, state.orderBy);
  };

  const DeletePopup = (state, id = "") => {
    setDelete((pre) => ({
      ...pre,
      open: state,
      dumpId: id,
    }));
  };

  const handleDelete = () => {
    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("Email Template Deleted!");
        setDelete((pre) => ({ open: false }));
        dispatch(smsTemp());
      } else {
        toast.error(response.message);
      }
    };
    dispatch(deleteSMSTemp({ userId: Delete.dumpId }, callBack));
  };

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(dragUsers);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setDragUsers(tempData);

    let body = {
      id: e?.draggableId,
      current_index: JSON.stringify(e?.source?.index + 1),
      destination_index: JSON.stringify(e?.destination?.index + 1),
      action_on: "sms_templates",
    };
    dispatch(rowSorting(body));
  };

  return (
    <>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">SMS Templates</h4>
              </div>
            </Col>
            <div className="bg-white px-4 py-3 card-box">
              <Filters
                status={state.status}
                handleStatus={handleStatus}
                columns={state.columns}
                filter={filter}
                handleSearchChange={handleSearchChange}
                filterdata={filterdata}
                resetFilter={resetFilter}
              />
              <div className="table-responsive py-3">
                <DragDropContext onDragEnd={handleDragEnd}>
                  <DataTable className="">
                    <DataTableHead
                      columns={columnData}
                      orderBy={state.orderBy}
                      // sort={this.handleRequestSort}
                    />
                    <Droppable droppableId="droppable-1">
                      {(provider) => (
                        <DataTableBody
                          loading={loading}
                          column={columnData}
                          data={dragUsers}
                          page={state.page}
                          rowsPerPage={state.limit}
                          innerRef={provider.innerRef}
                          dropProp={provider.droppableProps}
                          actionBtn={[
                            { label: "Delete", icon: "", action: DeletePopup },
                            {
                              label: "Edit",
                              icon: "",
                              link: "/sms-templates/edit",
                            },
                          ]}
                        />
                      )}
                    </Droppable>
                  </DataTable>
                </DragDropContext>
                {dragUsers?.length > 0 && (
                  <DataTablePagination
                    count={totalCount}
                    rowsPerPage={state.limit}
                    page={state.page}
                    onPageChange={handleChangePage}
                    rowsPerPageOptions={[]}
                  />
                )}
              </div>
            </div>
          </Row>
        </Container>
      </section>

      <Modal
        show={Delete.open}
        onHide={deleteClose}
        className="deleteAdd-pop delete-pop"
        centered
      >
        {/* <Modal.Header closeButton>
        </Modal.Header> */}
        <Modal.Body>
          <div className="text-center py-3">
            <div className="icn my-3">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256    C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216    c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"
                  fill="#f8c886"
                ></path>
                <path
                  d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877    C276,137.831,267.046,128.877,256,128.877z"
                  fill="#f8c886"
                ></path>
                <circle cx="256" cy="349.16" r="27" fill="#f8c886"></circle>{" "}
              </svg>
            </div>
            <h2 className="pop-head m-0 pb-2">Are you Sure?</h2>
            <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3">
              <div className="pe-2 w-50">
                <Button
                  className="btn-2 w-100 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setDelete(false);
                  }}
                >
                  No Cancel!
                </Button>
              </div>
              <div className="pe-2 w-50">
                <Button
                  onClick={handleDelete}
                  className=" w-100 d-flex align-items-center justify-content-center"
                >
                  Yes, Delete it
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default SMSIndex;
